import React, { useState } from 'react';
import type { Swiper as SwiperType } from 'swiper';
import { Image } from '@lt/components';
import SwiperCore, {
  Navigation,
  Scrollbar,
  Mousewheel,
  Pagination,
  Thumbs,
  Keyboard,
  FreeMode,
} from 'swiper';
import type { PopupSwiperProps } from 'src/components/GallerySwiper/types';
import { PopupSwiper } from 'src/components/GallerySwiper/components/PopupSwiper';
import classnames from 'classnames';
import { useTranslation } from '@lt/localization';
import type { GallerySwiperReviewCardDesktopProps } from './types';

import styles from './gallerySwiperReviewCard.module.css';

SwiperCore.use([
  Navigation,
  Scrollbar,
  Mousewheel,
  Pagination,
  Thumbs,
  Keyboard,
  FreeMode,
]);

const GallerySwiperReviewCardDesktop = ({
  images,
  title,
  className,
}: GallerySwiperReviewCardDesktopProps) => {
  const { t } = useTranslation();
  const galleryImages = images.map((image, index) => ({
    fullImage: image.full,
    smallImage: image.x180 ?? image.full,
    id: index,
  }));
  const [opened, setOpened] = useState(false);
  const [realIndexSlide, setRealIndexSlide] = useState(0);
  const [swiperGalleryPopup, setSwiperGalleryPopup] =
    useState<null | SwiperType>(null);

  const openPopup = (index: number) => {
    setRealIndexSlide(index);
    setOpened(true);
  };
  const closePopup = () => {
    setOpened(false);
  };
  const swiperPopupProps: PopupSwiperProps = {
    opened,
    images: galleryImages.map((image) => image.fullImage),
    title,
    isMobile: false,
    swiperGalleryPopup,
    realIndexSlide,
    closePopup,
    setSwiperGalleryPopup,
  };
  return (
    <div
      className={classnames(
        styles.container,
        styles.containerDesktop,
        className,
      )}
    >
      <div className={styles.galleryDesktop}>
        {galleryImages.slice(0, 9).map((image, index) => (
          <div className={styles.galleryDesktopSlide} key={`slide-${image.id}`}>
            <Image
              src={image.smallImage}
              fallback={image.smallImage}
              key={`review-card-${image.id}`}
              onClick={() => openPopup(index)}
            />
            {/* Показываем количество оставшихся фоток на девятой */}
            {index === 8 && galleryImages.length >= 8 && (
              <button
                type="button"
                className={styles.disableScrollVariant}
                onClick={() => openPopup(index)}
              >
                {`${images.length} ${t('hotel.topMenu.gallery').toLowerCase()}`}
              </button>
            )}
          </div>
        ))}
      </div>
      <PopupSwiper {...swiperPopupProps} />
    </div>
  );
};

export default GallerySwiperReviewCardDesktop;
